import React, { useCallback, useContext, useEffect, useState } from "react";
import CommonSectionHeader from "./CommonSectionHeader";
import { LanguageContext, VendorContext } from "../../../App";
import OtpInput from "react-otp-input";
import { tele, telecount } from "../../../services/constants";
import ReactFlagsSelect from "react-flags-select";
import { resendOTPApi } from "../../APIS/userApi";
import Spinner from "../../../SVGs/Spinner";
import toast, { Toaster } from "react-hot-toast";
import Title from "./Title";
import CommonBackButton from "../../NewSideBar/Components/CommonBackButton";
import BackComponent from "./BackComponent";

const OtpVerification = ({
  contactDetails,
  setContactDetails,
  openOtpPage,
  setOpenOtpPage,
  otpSent,
  setOtpSent,
  otp,
  setOtp,
}) => {
  const { language } = useContext(LanguageContext);
  const details = useContext(VendorContext);
  const [seconds, setSeconds] = useState(59);
  const [minutes, setMinutes] = useState(0);
  const [timerStatus, setTimerStatus] = useState(otpSent);
  const [loading, setLoading] = useState(false);
  const [otpSentMethod, setOtpSentMethod] = useState(1);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("contactInfo"))) {
      const contactInfo = JSON.parse(localStorage.getItem("contactInfo"));

      setContactDetails({
        ...contactDetails,
        phoneCode: contactInfo.code,
      });
    }
  }, []);

  function updateTime() {
    if (minutes == 0 && seconds == 1) {
      setTimerStatus(false);
    } else {
      if (seconds == 0) {
        setMinutes((minutes) => minutes - 1);
        setSeconds(59);
      } else {
        setSeconds((seconds) => seconds - 1);
      }
    }
  }

  useEffect(() => {
    if (timerStatus) {
      const token = setTimeout(updateTime, 1000);

      return function cleanUp() {
        clearTimeout(token);
      };
    }
  }, [timerStatus, minutes, seconds]);

  const formatTime = (time) => {
    return time.toString().padStart(2, "0");
  };

  const resendOtpFunction = async (isSMS) => {
    setOtp("");
    setLoading(true);
    setOtpSentMethod(isSMS ? 2 : 1);
    const response = await resendOTPApi({
      country_code: `+${tele[contactDetails.phoneCode]}`,
      phone_number: contactDetails.phone,
      sendSMS: isSMS,
      vendor_ecom_id: details?.vendor?.ecommerce_vendor_id,
      user_id: localStorage.getItem("id"),
      language: language,
    });
    setLoading(false);
    if (response?.status) {
      toast.success(
        language === "ltr" ? "OTP sent sucessfully " : "تم إرسال OTP بنجاح"
      );
      setOtpSent(true);
      setSeconds(59);
      setMinutes(0);
      setTimerStatus(true);
    } else {
      toast.error(response?.message);
    }
  };

  return (
    <div>
      <div className="toasterDiv">
        <Toaster position="top-left" reverseOrder={false} />
      </div>

      <Title
        englishTitle="One Time Password Authentication"
        arabicTitle="مصادقة كلمة المرور لمرة واحدة"
      />

      <div>
        <div className="enterOtpText">
          {language === "ltr" ? "Enter OTP" : "أدخل كلمة المرور لمرة واحدة"}
        </div>
        <div style={{ marginTop: "5px" }}>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={4}
            inputType="number"
            inputStyle={{
              height: "45px",
              width: "45px",
              borderRadius: "10px",
              border: "1px solid #E1E1E1",
              outline: "none",
              color: "#000",
              fontSize: "14px",
            }}
            containerStyle={{
              gap: "10px",
            }}
            renderSeparator={<span></span>}
            renderInput={(props, index) => (
              <input
                type="number"
                {...props}
                autoFocus={index === 0}
                autoComplete="one-time-code"
              />
            )}
          />
        </div>
      </div>

      <div className="sentOtpDiv">
        {details?.vendor?.checkout_method === "2"
          ? language === "ltr"
            ? `OTP sent to +${tele[contactDetails?.phoneCode]} ${
                contactDetails?.phone
              }`
            : `تم إرسال كلمة المرور لمرة واحدة (OTP) إلى +${
                tele[contactDetails?.phoneCode]
              } ${contactDetails?.phone}`
          : language === "ltr"
          ? `OTP sent to ${contactDetails?.email}`
          : `تم إرسال كلمة المرور لمرة واحدة (OTP) إلى ${contactDetails?.email}`}
      </div>

      <div className="blueBox" style={{ marginTop: "55px" }}>
        <img src="pictures/Sent.png" className="sentImg" />
        <div>
          <div
            style={{
              fontSize: language === "ltr" ? "13px" : "14px",
              fontWeight: 500,
            }}
          >
            {otpSentMethod == 1
              ? details?.vendor?.checkout_method === "2"
                ? language === "ltr"
                  ? "OTP Sent Via Whatsapp"
                  : "يتم إرسال OTP عبر Whatsapp"
                : language === "ltr"
                ? "OTP sent via Email"
                : "يتم إرسال OTP عبر البريد الإلكتروني"
              : language === "ltr"
              ? "OTP Sent Via SMS"
              : "يتم إرسال OTP عبر الرسائل القصيرة"}
          </div>
          {timerStatus ? (
            <div
              style={{
                color: "#636363",
                fontSize: language === "ltr" ? "11px" : "12px",
              }}
            >
              {formatTime(minutes)}:{formatTime(seconds)}
            </div>
          ) : null}
        </div>
      </div>

      <div style={{ marginTop: "10px" }}>
        <div className="resendOtpText">
          {language === "ltr"
            ? "Didn't receive OTP?"
            : "لم تتلق كلمة المرور لمرة واحدة؟"}
        </div>

        <div
          className={"resendOtpText"}
          style={{ marginTop: "2px", color: timerStatus ? "#adb5bd" : "#000" }}
          onClick={() => {
            if (!timerStatus) {
              resendOtpFunction(false);
            }
          }}
        >
          <span>
            {language === "ltr"
              ? "Resend OTP"
              : "إعادة إرسال كلمة المرور لمرة واحدة"}
          </span>
        </div>
        {details?.vendor?.checkout_method === "2" ? (
          <div
            className={"resendOtpText"}
            style={{
              marginTop: "15px",
              color: timerStatus ? "#adb5bd" : "#000",
            }}
            onClick={() => {
              if (!timerStatus) {
                resendOtpFunction(true);
              }
            }}
          >
            <span>
              {language === "ltr"
                ? "Resend via SMS"
                : "إعادة الإرسال عبر الرسائل القصيرة"}
            </span>
          </div>
        ) : null}
      </div>

      {loading && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            position: "fixed",
            top: "0",
            left: "0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "8",
          }}
          className="order-spinner-background"
        >
          <Spinner
            height="50px"
            color={details?.vendor?.vendor_color}
            size="6px"
          />
        </div>
      )}
    </div>
  );
};

export default OtpVerification;
